export * from './corporate-tariff';

